import { IAgent } from "./AgentInterface";
import axios from "axios";
import { buildNCDHeaders, ENV } from "../../utils";
import { handleAxiosError } from "../../axiosHelper";
import { getEnvKey } from "../../environment";
import FeatureFlagsBuilder from "../FeatureFlags";
import { IFeatureFlags } from "../FeatureFlags/FeatureFlagsInterface";

export default class Agent implements IAgent {
  id?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: number;
  parentAgentId?: number;
  featureFlags?: IFeatureFlags;
  createdAt?: Date;

  constructor(
    id?: number,
    firstName?: string,
    lastName?: string,
    email?: string,
    phoneNumber?: number,
    parentAgentId?: number,
    createdAt?: Date
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.parentAgentId = parentAgentId;
    this.createdAt = createdAt;
  }

  /**
   * @name loginAgent
   * @param agentId
   * @description this function takes the ID of an Agent and validates it to give it access
   * */
  loginAgent = async (agentId = this.id, setAgentState: React.Dispatch<React.SetStateAction<Agent>>, appId?: string) => {
    return await axios
      .get(`${getEnvKey(ENV.REACT_APP_AGENTLOGINLAMBDAURL)}/${agentId}`,
        {
          headers: buildNCDHeaders(agentId, appId)
        })
      .then((response) => {
        const agent = JSON.parse(response.data);
        const createdAt = new Date(agent.CREATED_AT ?? Date.now());
        this.id = agent.ID;
        this.firstName = agent.FIRSTNAME;
        this.lastName = agent.LASTNAME;
        this.email = agent.EMAIL;
        this.phoneNumber = agent.PHONE1;
        this.parentAgentId = agent.PARENT.ID;
        this.createdAt = createdAt;

        const featureFlagMetrics = {
          createdAt: createdAt,
          parentId: agent.PARENT.ID
        }
        const featureFlagsFromServer = {planExclusions: undefined, effectiveDateXMonthsOut: undefined}
        const featureFlagsBuilder = new FeatureFlagsBuilder(featureFlagsFromServer, featureFlagMetrics);
        this.featureFlags = featureFlagsBuilder.featureFlags
        setAgentState({ ...this }) // make a new object for setState
        return response;
      })
      .catch((error) => {
        return handleAxiosError(error)
      });
  };

  /**
   * @name getAgentlicnese
   * @param agentId
   * @description Gets the agent licenses
   * */
  getAgentLicense = async (agentId = this.id, appId?: string) => {
    return await axios
      .get(`${process.env.REACT_APP_AGENTLICENSELAMBDAURL}/${agentId}`,
        {
          headers: buildNCDHeaders(agentId, appId)
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        handleAxiosError(error)
        return '[]'
      });
  };
}
